/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
// https://open.dingtalk.com/document/orgapp-client/scan-barcodes-and-qr-codes?spm=ding_open_doc.document.0.0.c97f4399SeHacV#topic-2025276
function scan(options, context) {
    var _a;
    var api = 'dd.biz.util.scan';
    var formatOutput = function (ret) { return ({
        code: ret === null || ret === void 0 ? void 0 : ret.text,
        qrCode: ret === null || ret === void 0 ? void 0 : ret.text,
        barCode: ret === null || ret === void 0 ? void 0 : ret.text,
    }); };
    var formatInput = function (input) {
        var _a;
        var _b = (input !== null && input !== void 0 ? input : {}).scanType, scanType = _b === void 0 ? ['qrCode', 'barCode'] : _b;
        // qrCode：二维码
        // barCode：条形码
        // all（默认）：全部
        if ((scanType === null || scanType === void 0 ? void 0 : scanType.length) === 1) {
            return { type: (_a = scanType[0]) !== null && _a !== void 0 ? _a : 'all' };
        }
        return { type: 'all' };
    };
    (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatInput: formatInput, formatOutput: formatOutput });
}

export { scan as default };
